import { WA_WINDOW } from '@ng-web-apis/common';
import {
  DOCUMENT,
  inject,
  Injectable,
  Renderer2,
  RendererFactory2,
} from '@angular/core';
import { environment } from '@environment/environment';
import { AuthLoginService } from './auth-login.service';
import { AuthLoginWindow } from './auth-login.types';

@Injectable({
  providedIn: 'root',
})
export class AuthScriptLoaderService {
  private readonly document = inject(DOCUMENT);
  private readonly authWindow = inject(WA_WINDOW) as AuthLoginWindow;
  private readonly renderer = inject(RendererFactory2).createRenderer(
    null,
    null,
  );
  private readonly authLoginService = inject(AuthLoginService);
  private scriptInjected = false;

  ensureLoaded(): void {
    this.authWindow.X_AUTH_LOGIN_HOST = environment.loginHost;

    if (this.scriptInjected) {
      return;
    }

    this.scriptInjected = true;
    this.injectAuthScript(this.document, this.renderer);
  }

  private injectAuthScript(document: Document, renderer: Renderer2): void {
    const script = renderer.createElement('script') as HTMLScriptElement;

    script.onload = () => this.authLoginService.markAuthScriptReady();
    script.onerror = () => this.authLoginService.markAuthScriptFailed();
    script.src = `${environment.loginHost}/scripts/auth.js`;
    renderer.appendChild(document.body, script);
  }
}
